module.exports = __webpack_public_path__ + "static/media/Spritzee_gaussian2.4385dff8.png";